import { selectTicketTypes } from "app/redux/selector";
import React from "react";
import { useSelector } from "react-redux";
import { ITicketFormData, TicketGroup } from "../../containers/Tickets/types";
import DueDateSection from "./DuedateSection";
import PrioritySelection from "./PrioritySelection";
import SelectAssignee from "./SelectAssignee";
import SelectStatus from "./SelectStatus";
import TagSelection from "./TagSelection";
import TypeSelection from "./TypeSelection";

interface Props {
  onOpen: () => void;
  onClose: () => void;
  form: ITicketFormData;
  handleSelect: (name: string, value: any) => void;
  group: TicketGroup;
  projectId: string;
}

const Fields: React.FC<Props> = ({
  onClose,
  onOpen,
  form,
  handleSelect,
  group,
  projectId,
}) => {
  const ticketTypes = useSelector(selectTicketTypes);
  return (
    <>
      <TypeSelection
        type={form?.type}
        setValue={(val) => {
          handleSelect("type", val);
        }}
        ticketTypes={ticketTypes}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
      />
      <SelectStatus
        status={form?.status}
        setValue={(val) => {
          handleSelect("status", val);
        }}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
      />
      <SelectAssignee
        assignedTo={form.assignedTo}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
        projectId={projectId}
        onUpdate={(val) => {
          handleSelect("assignedTo", val);
        }}
      />
      <PrioritySelection
        value={form.priority as string}
        setValue={(val) => {
          handleSelect("priority", val);
        }}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
      />
      <TagSelection
        selectedTags={form?.tags}
        onTagsChange={(val) => {
          handleSelect("tags", val);
        }}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
      />
      <DueDateSection
        dueDate={form?.dueDate}
        onDateChange={(val) => {
          handleSelect("dueDate", val);
        }}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
      />
    </>
  );
};

export default Fields;
